import type { NavigationItem } from "@/components/ui/navigation/types";

/**
 * The serializable subset of a NavigationItem persisted to localStorage.
 * Icons (React component functions) and descriptions are intentionally
 * omitted — they are restored from the default config on load.
 */
export interface SerializedNavItem {
  id: string;
  name: string;
  href: string;
  visible?: boolean;
  order?: number;
  children?: SerializedNavItem[];
}

/**
 * Recursively strips a NavigationItem tree down to its serializable fields.
 * Children visibility + order are preserved so submenu customization survives
 * a reload (previously only top-level items round-tripped).
 */
export function serializeNavItems(items: NavigationItem[]): SerializedNavItem[] {
  return items.map((item) => ({
    id: item.id,
    name: item.name,
    href: item.href,
    visible: item.visible,
    order: item.order,
    children: item.children ? serializeNavItems(item.children) : undefined,
  }));
}
